import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {
  filter?: string
  numberOfItems?: number
  page: number
}

export type Variables = {
  filter?: string
  numberOfItems?: number
  page: number
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const PRICE_OVERVIEW_QUERY = gql`
  query getPriceOverview($filter: String = "", $numberOfItems: Float = 15, $page: Float! = 1) {
    getPriceOverview(filter: $filter, numberOfItems: $numberOfItems, page: $page) {
      articles {
        id: articleNumber
        articleNumber
        articleName
        supplier
        unit
        listPrice
        customPrice
      }
      currentPage
      totalPages
    }
  }
`

const withPriceOverviewQuery = graphql<InputProps, Response, Variables, ChildProps>(
  PRICE_OVERVIEW_QUERY,
  { name: 'priceOverviewData', options: { fetchPolicy: 'network-only' } },
)

export default withPriceOverviewQuery
